.wrap.descOpen {
}

.daysContainer {
  height: 100%;
}